/* unplugin-vue-components disabled */import script from "./TierLocalPriceTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./TierLocalPriceTable.vue?vue&type=script&lang=ts&setup=true"

import "./TierLocalPriceTable.vue?vue&type=style&index=0&id=ef24c86c&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef24c86c"]])

export default __exports__